export default {
    modify_collection_item: '修改收集项',
    edit_collection_item: '编辑收集项',
    add_new_collection_item: '新增收集项',
    field_name: '字段名称',
    field_type: '字段类型',
    attention_phone_number: '注意!!!!!*****★★★★★：姓名手机号请选择系统自带的姓名手机号字段类型否则数据会统计失误！切记！！！！',
    uploadable_recruitment_types: '可上传录用类型',
    select_company_collection_item: '请选择单位收集项',
    house_number_address: '门牌地址',
    postal_code: '邮政编码',
    upload_template_file: '上传模板文件',
    click_to_view_file: '点击查看文件',
    award_configuration: '评奖配置',
    award_type: '评奖类型',
    select_evaluation_type: '请选择评选类型',
    upload_id_card: '上传身份证',
    age_limit: '按年龄限制',
    province_limit: '按省份限制',
    show_yes_no_option: '显示是否选项',
    max_age_limit: '最大年龄限制',
    enter_max_age_limit: '请输入最大年龄限制',
    province_restriction: '省份限制',
    select_province: '请选择省份',
    option_content: '选项内容',
    upload_file_format: '上传文件格式',
    system_field_content_not_editable: '系统字段内容不予许更改',
    calendar_format: '日历格式',
    custom_format: '自定义格式',
    enter_date_type: '请输入日期类型',
    date_format_example: '格式\t：yyyy-MM-dd HH:mm:ss',
    date_value_example: '示例值：2023-08-18 20:08:08',
    max_options: '最多可选几项',
    no_option_limit: '此处为空或为0的时候不限制可选择数量。',
    resume_min_words: '个人简历最少字数',
    no_word_limit: '此处为空或为0的时候不限制！ 注意：英文网站按单词数量限制。',
    resume_max_words: '个人简历最大字数',
    this_field_is_required: '此项必填',
    parent_option_and_display_condition: '父级选项及显示条件',
    parent_option: '父级选项',
    parent_option_order_note: '注意：父级选项排序必须放子级字段前面',
    display_condition: '显示条件',
    display_field_condition: '当父级选项，选择此条件后则会显示此项字段',
    enter_display_name: '请输入显示名称',
    prompt_text: '提示文字',
    empty_value_prompt: '值为空时提示',
    date_format_example: '格式：',
    date_value_example: '示例值：',
    select_reg: '请选择{reg}的文件格式',
    new_channel: '新增渠道',
    edit_channel: '编辑渠道',
    general_configuration: '通用配置',
    channel_id: '渠道ID',
    enter_channel_id: '请输入分类ID',
    show_in_left_menu: '是否在左侧菜单单独显示',
    show: '显示',
    not_show: '不显示',
    max_submission_limit: '限制每个人最大投稿数量',
    default_no_limit: '默认数量0为不限制',
    manuscript_language: '稿件语言',
    collect_other_authors: '是否收集其他作者信息',
    collect_corresponding_author: '是否收集通讯作者',
    collect_speaking_author: '是否收集发言作者',
    min_abstract_words: '摘要最少字数',
    max_abstract_words: '摘要最大字数',
    complete_language_info: '请至少完善一个语言信息',
    is_open: '是否开放',
    channel_name: '渠道名称',
    submission_instructions: '投稿须知',
    show_statement_confirmation: '是否开启声明确认',
    statement_confirmation_title: '声明确认标题文字',
    statement_confirmation_details: '声明确认详细内容',
    update_class: '更新分类',
    class_id: '分类ID',
    parent_class: '父级分类',
    chinese_name: '中文名称',
    english_name: '英文名称',
    short_name: '名称缩写',
    supported_channels: '支持渠道',
    poster_cover_image: '壁报封面展示图片',
    image_format_support: '支持JPG、GIF、PNG图片文件, 建议尺寸 1080*1920',
    upload_image: '上传图片',
    please_select_status: '请选择状态',
    first_category: '一级分类',
    submission_is_open: '是否开启网站投稿',
    submission_open: '开',
    submission_close: '关',
    submission_deadline: '投稿截止日期',
    first_author_restriction: '第一作者限制',
    first_author_must_be_submitter: '第一作者必须为投稿者',
    first_author_can_choose: '第一作者可任意选择',
    max_submissions_per_user: '限制每个人最大投稿数量',
    default_no_limit_hint: '默认数量0为不限制',
    chinese_submit_button_text: '中文投稿按钮文字',
    chinese_submit_button_hint: '前台代表登录后左侧菜单文字',
    chinese_custom_url: '中文投稿自定义链接',
    chinese_preview_name: '中文投稿预览名称',
    chinese_submit_text: '中文投稿提交按钮文字',
    english_submit_button_text: '英文投稿按钮文字',
    english_custom_url: '英文投稿自定义链接',
    english_preview_name: '英文预览名称',
    english_submit_text: '英文投稿提交按钮文字',
    link_format_error: '链接格式不正确',
    status_open: '开放',
    status_closed: '未开放',
    category_name_placeholder: '请输入分类名称',
    add_channel_button: '添加渠道',
    submission_limit_column: '投稿限制',
    delete_confirmation: '您确定要删除当前分类吗？',
    delete_channel: '您确定要删除当前渠道吗？',
    status_update_success: '状态修改成功',
    no_limit: '不限制',
    max_send_num: '最大投稿数',
    cn_web: '中文网站',
    en_web: '英文网站',
    channel_config: '渠道配置',
    first_author: '第一作者',
    other_author: '其他作者',
    collect_content: '论文收集内容',
    upload_collect: '上传资料收集',
    base_params: {
        title: '基础参数',
        submit: '提交',
        reset: '重置',
        save_success: '保存成功',
        save_failed: '保存失败',
        form_title: '表单标题',
        enter_form_title: '请输入表单标题',
        form_type: '表单类型',
        select_form_type: '请选择表单类型',
        form_status: '表单状态',
        select_form_status: '请选择表单状态',
        form_desc: '表单描述',
        enter_form_desc: '请输入表单描述',
        form_sort: '表单排序',
        enter_form_sort: '请输入表单排序',
        form_required: '是否必填',
        form_visible: '是否可见',
        form_editable: '是否可编辑',
        form_default: '默认值',
        enter_form_default: '请输入默认值',
        form_placeholder: '占位符',
        enter_form_placeholder: '请输入占位符',
        form_validation: '验证规则',
        enter_form_validation: '请输入验证规则',
        form_error_msg: '错误提示',
        enter_form_error_msg: '请输入错误提示',
        loading: '加载中...',
        is_open: '是否开启网站投稿',
        open: '开',
        close: '关',
        deadline: '投稿截止日期',
        first_author_limit: '第一作者限制',
        first_author_must_be_submitter: '第一作者必须为投稿者',
        first_author_can_choose: '第一作者可任意选择',
        max_submissions: '限制每个人最大投稿数量',
        no_limit_hint: '默认数量0为不限制',
        chinese: '中文',
        english: '英文',
        chinese_submit_button: '中文投稿按钮文字',
        chinese_submit_button_hint: '前台代表登录后左侧菜单文字',
        chinese_custom_url: '中文投稿自定义链接',
        chinese_preview_name: '中文投稿预览名称',
        chinese_submit_text: '中文投稿提交按钮文字',
        english_submit_button: '英文投稿按钮文字',
        english_custom_url: '英文投稿自定义链接',
        english_preview_name: '英文预览名称',
        english_submit_text: '英文投稿提交按钮文字',
        please_enter: '请输入',
        submit: '立即提交',
        invalid_url: '链接格式不正确'
    },
    class_params: {
        select_status: '是否开放',
        enabled: '启用',
        disabled: '未启用',
        enter_class_name: '请输入分类名称',
        search: '搜索',
        add_class: '添加分类',
        open: '开启',
        close: '关闭',
        add_sub_class: '增加子分类',
        edit: '编辑',
        delete: '删除',
        sort: '排序',
        class_name: '分类名称',
        class_name_en: '英文名称',
        status: '状态',
        action: '操作',
        confirm_title: '提示',
        delete_confirm_msg: '您确定要删除当前分类吗？',
        confirm: '确定',
        cancel: '取消',
        delete_success: '删除成功',
        delete_failed: '删除失败',
        status_change_success: '状态修改成功'
    },
    channel_params: {
        title: '渠道参数',
        add_channel: '新增渠道',
        edit_channel: '编辑渠道',
        delete_channel: '删除渠道',
        channel_name: '渠道名称',
        enter_channel_name: '请输入渠道名称',
        channel_code: '渠道编码',
        enter_channel_code: '请输入渠道编码',
        channel_sort: '渠道排序',
        enter_channel_sort: '请输入渠道排序',
        channel_status: '渠道状态',
        select_channel_status: '请选择渠道状态',
        channel_desc: '渠道描述',
        enter_channel_desc: '请输入渠道描述',
        confirm_delete: '确认删除',
        delete_confirm_msg: '确定要删除该渠道吗？',
        delete_success: '删除成功',
        delete_failed: '删除失败',
        save_success: '保存成功',
        save_failed: '保存失败'
    },
    form_params: {
        title: '表单参数',
        add_field: '新增字段',
        edit_field: '编辑字段',
        delete_field: '删除字段',
        field_name: '字段名称',
        enter_field_name: '请输入字段名称',
        field_code: '字段编码',
        enter_field_code: '请输入字段编码',
        field_type: '字段类型',
        select_field_type: '请选择字段类型',
        field_sort: '字段排序',
        enter_field_sort: '请输入字段排序',
        field_status: '字段状态',
        select_field_status: '请选择字段状态',
        field_desc: '字段描述',
        enter_field_desc: '请输入字段描述',
        field_required: '是否必填',
        field_visible: '是否可见',
        field_editable: '是否可编辑',
        field_default: '默认值',
        enter_field_default: '请输入默认值',
        field_placeholder: '占位符',
        enter_field_placeholder: '请输入占位符',
        field_validation: '验证规则',
        enter_field_validation: '请输入验证规则',
        field_error_msg: '错误提示',
        enter_field_error_msg: '请输入错误提示',
        confirm_delete: '确认删除',
        delete_confirm_msg: '确定要删除该字段吗？',
        delete_success: '删除成功',
        delete_failed: '删除失败',
        save_success: '保存成功',
        save_failed: '保存失败',
        back_to_channel_list: '返回渠道列表',
        loading: '加载中...',
        system_field_notice: '注意：优先使用系统字段，否则会影响后期统计和导出数据有问题！',
        selected_form_items: '已选表单项',
        required: '必填',
        upload_file: '上传文件',
        yes: '是',
        no: '否',
        select_collection_items: '选择收集项',
        system: '系统',
        edit: '编辑',
        add_custom_collection_item: '添加自定义收集项'
    },
    payment_params: {
        title: '支付参数',
        payment_type: '支付类型',
        select_payment_type: '请选择支付类型',
        payment_name: '支付名称',
        enter_payment_name: '请输入支付名称',
        payment_code: '支付编码',
        enter_payment_code: '请输入支付编码',
        payment_sort: '支付排序',
        enter_payment_sort: '请输入支付排序',
        payment_status: '支付状态',
        select_payment_status: '请选择支付状态',
        payment_desc: '支付描述',
        enter_payment_desc: '请输入支付描述',
        payment_config: '支付配置',
        enter_payment_config: '请输入支付配置',
        save_success: '保存成功',
        save_failed: '保存失败',
        loading: '加载中...',
        enable_payment: '是否开启稿件支付',
        open: '开',
        close: '关',
        domestic_currency: '中宾支付币种',
        domestic_amount: '中宾支付金额',
        foreign_currency: '外宾支付币种',
        foreign_amount: '外宾支付金额',
        payment_deadline: '支付截止日期',
        submit: '立即提交'
    },
    abstract_edit: {
        edit_abstract: '稿件编辑',
        add_abstract: '新增稿件',
        select_channel: '选择渠道',
        submitter_info: '提交者信息',
        user_id: '用户ID',
        name: '姓名',
        gender: '性别',
        family_name: '姓拼音',
        given_name: '名拼音',
        highest_degree: '最高学历',
        technical_title: '技术职称',
        province: '所属省市',
        area: '所属地区',
        administrative_position: '行政职务',
        workplace: '工作单位',
        department: '科室部门',
        address: '门牌地址',
        postal_code: '邮政编码',
        mobile: '联系手机',
        work_phone: '单位电话',
        email: '邮箱',
        all_orgs: '论文作者所有单位',
        org_name: '单位名称',
        org_address: '单位地址',
        org_postal_code: '单位邮编',
        action: '操作',
        add_org: '添加单位',
        all_authors: '所有作者信息',
        abstract_content: '稿件内容',
        other_settings: '其他设置',
        submission_status: '投稿状态',
        select_submission_status: '请选择投稿状态',
        completed: '已完成',
        not_completed: '未完成',
        final_acceptance_type: '最终录用形式',
        select_acceptance_type: '请选择最终录用形式',
        no_acceptance_type: '无最终录用类型',
        paper_number: '论文编号',
        enter_paper_number: '请输入论文编号',
        show_electronic_poster: '是否展示电子壁报',
        select_show_poster: '请选择是否展示电子壁报',
        not_show: '不展示',
        show: '展示',
        accept: '是否接受',
        select_accept: '请选择是否接受',
        feedback: '反馈意见',
        close: '关闭',
        submit: '提交'
    },
    add_author: {
        edit_author: '编辑作者',
        add_author: '新增作者',
        author_org: '作者所属单位',
        select_author_org: '请选择作者单位',
        corresponding_author: '通讯作者',
        speaking_author: '发言作者'
    },
    add_org: {
        title: '添加单位',
        org_name: '单位名称',
        enter_org_name: '请输入单位名称',
        org_address: '单位地址',
        enter_org_address: '请输入单位地址',
        org_postal_code: '单位邮编',
        enter_org_postal_code: '请输入单位邮编',
        cancel: '取消',
        submit: '提交'
    },
    all_author: {
        all_authors: '本论文所有作者',
        add_author: '添加作者',
        author_number: '第{number}作者',
        name: '姓名',
        mobile: '手机',
        email: '电子邮箱',
        corresponding_author: '通讯作者',
        speaking_author: '发言作者',
        belonging_org: '所属单位'
    },
    abstract_audit: {
        title: '稿件审核',
        topic_category: '主题分类',
        abstract: '摘要',
        keywords: '关键字',
        audit_opinion: '审核意见',
        enter_audit_opinion: '请输入审核意见',
        approve: '通过',
        reject: '驳回',
        submit_success: '提交成功'
    },
    abstract_detail: {
        topic_category: '主题分类：',
        abstract: '摘要：',
        keywords: '关键字：'
    },
    email_template: {
        title: '标题',
        enter_title: '请输入标题',
        sender_name: '发件人名称',
        enter_sender_name: '请输入发件人名称',
        email_address: '发送/接收邮箱',
        enter_email_address: '请输入发送/接收邮箱',
        email_subject: '邮箱主题',
        enter_email_subject: '请输入邮箱主题',
        template_content: '模板内容',
        is_enabled: '是否启用',
        yes: '是',
        no: '否',
        close: '关闭',
        submit: '提交',
        submit_success: '提交成功'
    },
    sms_title: '标题',
    sms_enter_title: '请输入标题',
    sms_template_content: '模板内容',
    sms_max_length_tip: '一次发放短信内容的最长字符数不超过500字符',
    sms_signature: '短信签名',
    sms_signature_option1: '会务通',
    sms_signature_option2: '会务组',
    sms_signature_tip: '签名通知：运营商已开启全局白名单管控功能，现提供 【会务通】【会务组】，如填写自定义签名，请直接写短信内容中。',
    sms_is_enabled: '是否启用',
    sms_yes: '是',
    sms_no: '否',
    sms_enabled_tip1: '注意：如果短信内容包含标签，则短信内容字符以替换标签后的字符数为准！',
    sms_enabled_tip2:
        '短信计费规则： 70字以内计费一条，超过70字,67个字计费一条，短信最多可以支持500字。 按字符计算，1个英文字母，1个数字，1个标点，1个空格，1个汉字，都算1个字。 长短信整条短信按67的倍数扣费。',
    sms_close: '关闭',
    sms_submit: '提交',
    sms_submit_success: '提交成功',
    email_history_detail: {
        email_content: '邮件内容',
        email: '邮箱',
        sender: '发送者',
        send_time: '发送时间',
        send_status: '发送状态',
        theme: '主题',
        operator_send_status: '运营商发送状态',
        send_return_value: '发送返回值',
        send_email_record: '发送邮件记录',
        enter_email: '请输入邮箱',
        status: '状态',
        all: '全部',
        not_send: '未发送',
        send_success: '发送成功',
        send_failed: '发送失败',
        send_processing: '发送中',
        query: '查询',
        email_send_record: '邮件发送记录',
        email_template_record: '发送模板记录',
        click_to_view: '点击查看',
        num: '数量（条）',
        operation: '操作',
        content: '内容',
        total_count: '总计：{totalCount}条'
    },
    email_view: {
        modal_title: '邮件内容',
        dear_dr: 'Dear Dr.',
        table1_id: 'ID',
        table1_title: '稿件题目',
        table1_first_author: '第一作者',
        table1_result: '评审结果',
        table1_author: '作者',
        table1_paper_title: '题目',
        table1_result_value: '结果',
        row_paper_number: '论文序号',
        row_paper_title: '论文题目',
        row_first_author: '第一作者',
        row_all_authors: '所有作者',
        row_review_result: '评审结果',
        row_title: '题目',
        table2_id: 'ID',
        table2_title: '稿件题目',
        table2_first_author: '第一作者',
        table2_corresponding_author: '通讯作者',
        table2_result: '评审结果',
        table2_paper_title: '题目',
        table2_first_author_value: '第一作者',
        table2_corresponding_author_value: '通讯作者',
        table2_result_value: '结果'
    },
    upload: {
        poster_ppt_cn: '中文壁报',
        poster_ppt_en: '英文壁报',
        full_text_cn: '中文全文附件',
        full_text_en: '英文全文附件',
        ppt_cn: '中文PPT',
        ppt_en: '英文PPT',
        abstract_cn: '中文摘要',
        abstract_en: '英文摘要',
        video_url_cn: '中文视频',
        video_url_en: '英文视频'
    },
    abstract_list: {
        search_paper_id: '论文ID',
        search_title: '题目',
        search_first_author: '第一作者',
        search_first_author_org: '第一作者单位',
        search_first_author_province: '第一作者省份',
        search_submitter: '投稿作者',
        search_payment_status: '注册支付状态',
        search_payment_status_placeholder: '请选择支付状态',
        search_payment_status_paid: '已支付',
        search_payment_status_unpaid: '未支付',
        search_manuscript_status: '稿件状态',
        search_manuscript_status_placeholder: '请选择稿件状态',
        search_channel: '论文渠道',
        search_channel_placeholder: '请选择论文渠道',
        search_class: '论文类别',
        search_class_placeholder: '请选择论文类别',
        search_acceptance_type: '录用类型',
        search_acceptance_type_placeholder: '请选择录用类型',
        search_sort: '排序',
        search_sort_placeholder: '请选择排序',
        search_sort_desc: '按论文ID降序排序',
        search_sort_asc: '按论文ID升序排序',
        search_sort_update_time: '按最后更新时间排序',
        search_publish_type: '拟交流类型',
        search_publish_type_placeholder: '请选择拟交流类型',
        button_search: '搜索',
        button_add: '添加',
        button_clear: '清空',
        button_set_cn_notice: '设置中文录取通知函',
        button_set_en_notice: '设置英文录取通知函',
        button_email_record: '发送邮件记录',
        table_paper_id: '论文ID',
        table_class: '分类',
        table_title: '题目',
        table_first_author: '第一作者',
        table_submitter: '提交者',
        table_acceptance_type: '录用类型',
        table_channel: '渠道',
        table_attachment: '全文附件',
        table_upload_cn_attachment: '上传中文附件',
        table_upload_en_attachment: '上传英文附件',
        table_ppt: 'PPT',
        table_upload_cn_ppt: '上传中文PPT',
        table_upload_en_ppt: '上传英文PPT',
        table_poster: '电子壁报',
        table_upload_cn_poster: '上传中文壁报',
        table_upload_en_poster: '上传英文壁报',
        table_notice: '论文录取通知函',
        table_preview_email: '点击预览邮件',
        table_send_email: '点击发送邮件',
        table_last_update_time: '最后更新时间',
        table_action: '操作',
        table_edit: '编辑',
        table_delete: '删除',
        table_preview: '预览',
        table_download_attachment: '下载附件',
        delete_confirm_title: '',
        delete_confirm_content: '是否要删除该稿件',
        delete_success: '删除成功',
        attachment_not_exist: '附件不存在'
    },
    statistics: {
        hire_type: {
            title: '录用类型',
            total: '总数'
        },
        recommend_org: {
            title: '推荐单位',
            total: '总数'
        },
        type: {
            title: '类型',
            by_org: '按单位统计',
            by_province: '按省份统计',
            view: '查看'
        },
        author: {
            city: {
                title: '省份',
                total: '总数'
            },
            country: {
                title: '国家',
                total: '数量'
            },
            org: {
                title: '单位',
                total: '数量'
            },
            province: {
                title: '省份',
                total: '数量'
            }
        },
        modal: {
            org_title: '按照单位统计',
            province_title: '按照省份统计'
        },
        echarts: {
            type: '类型',
            class: '稿件类别',
            city: '投稿者省市',
            country: '第一作者国家',
            org: '第一作者单位',
            province: '第一作者省份',
            hire_type: '录用类型',
            recommend_org: '推荐单位'
        }
    },
    export_params: {
        paper_attachment_download: '论文附件下载' /* 论文附件下载 */,
        submission_channel: '投稿通道' /* 投稿通道 */,
        select_submission_channel: '请选择投稿通道' /* 请选择投稿通道 */,
        submission_category: '投稿类别' /* 投稿类别 */,
        all: '全部' /* 全部 */,
        proposed_communication_type: '拟交流类型' /* 拟交流类型 */,
        final_communication_type: '最终交流类型' /* 最终交流类型 */,
        data_type: '数据类型' /* 数据类型 */,
        paper_id_export: '需要导出论文的ID' /* 需要导出论文的ID */,
        export_by_order: '按此顺序导出' /* 按此顺序导出 */,
        one_per_line: '一行一个，不填导出全部' /* 一行一个，不填导出全部 */,
        export_paper_attachment: '论文附件导出' /* 论文附件导出 */,
        submit_success: '提交成功' /* 提交成功 */
    },
    export_template_params: {
        paper_export: '论文稿件导出' /* 论文稿件导出 */,
        submission_channel: '投稿通道' /* 投稿通道 */,
        select_submission_channel: '请选择投稿通道' /* 请选择投稿通道 */,
        submission_category: '投稿类别' /* 投稿类别 */,
        all: '全部' /* 全部 */,
        proposed_communication_type: '拟交流类型' /* 拟交流类型 */,
        final_communication_type: '最终交流类型' /* 最终交流类型 */,
        has_attachment: '是否有附件' /* 是否有附件 */,
        yes: '是' /* 是 */,
        no: '否' /* 否 */,
        template_content: '模板内容包含' /* 模板内容包含 */,
        proposed_type: '拟交流类型' /* 拟交流类型 */,
        final_type: '最终交流类型' /* 最终交流类型 */,
        category: '类别' /* 类别 */,
        paper_id: '论文id' /* 论文id */,
        chinese_title: '中文题目' /* 中文题目 */,
        english_title: '英文题目' /* 英文题目 */,
        paper_number: '论文编号' /* 论文编号 */,
        author_and_org: '作者和单位' /* 作者和单位 */,
        org_province: '单位所属省市' /* 单位所属省市 */,
        org_postal_code: '单位邮政编码' /* 单位邮政编码 */,
        contact_author: '通讯作者' /* 通讯作者 */,
        contact_author_email: '通讯作者邮箱' /* 通讯作者邮箱 */,
        abstract: '摘要' /* 摘要 */,
        keywords: '关键字' /* 关键字 */,
        references: '参考文献' /* 参考文献 */,
        barcode: '条形码' /* 条形码 */,
        awards: '评奖' /* 评奖 */,
        online_review_avg: '在线评审平均分' /* 在线评审平均分 */,
        online_review_status: '在线评审情况' /* 在线评审情况 */,
        first_author_photo: '第一作者照片、简历' /* 第一作者照片、简历 */,
        show_review_input: '显示评审结果输入框' /* 显示评审结果输入框 */,
        word_export_spec: 'word文档导出规格' /* word文档导出规格 */,
        merge_one_word: '合并成一个word文档' /* 合并成一个word文档 */,
        one_category_one_word: '一个类别一个word文档' /* 一个类别一个word文档 */,
        one_paper_one_word: '一篇稿一个word文档' /* 一篇稿一个word文档 */,
        paper_number_setting: '论文编号设置' /* 论文编号设置 */,
        title_setting: '标题设置' /* 标题设置 */,
        author_setting: '作者设置' /* 作者设置 */,
        org_setting: '单位设置' /* 单位设置 */,
        abstract_setting: '摘要设置' /* 摘要设置 */,
        keywords_setting: '关键字设置' /* 关键字设置 */,
        references_setting: '参考文献设置' /* 参考文献设置 */,
        title_author_separator: '标题和作者之间' /* 标题和作者之间 */,
        author_abstract_separator: '作者和摘要间' /* 作者和摘要间 */,
        keywords_abstract_separator: '关键字和上文之间' /* 关键字和上文之间 */,
        reference_abstract_separator: '参考文献和上文之间' /* 参考文献和上文之间 */,
        article_two_separator: '两篇文章间' /* 两篇文章间 */,
        paper_sort_rule: '论文排序规则' /* 论文排序规则 */,
        paper_id_export: '需要导出论文的ID' /* 需要导出论文的ID */,
        export_by_order: '按此顺序导出' /* 按此顺序导出 */,
        one_per_line: '一行一个，不填导出全部，一次做多填写4000个ID' /* 一行一个，不填导出全部，一次做多填写4000个ID */,
        export_word_format: '批量导出word格式' /* 批量导出word格式 */
    }
};
